import { useDispatch } from 'react-redux';
export const useTypeDispatch = () => useDispatch();
